import Reflux from 'reflux';
import Framework from 'framework';
import _ from 'ext:lodash';
import Cookies from 'cookies-js';
import constants from 'lib/constants';
import LocalStorage from 'lib/local-storage';
import urlUtils from 'lib/url-utils';
import { proxyToProfileStore } from './proxyToEnterpriseFramework';

var ProfileStore = null;

function getInitialMemberData() {
	var memberData = null;
	var isSsoParam = Framework.global.location.search && urlUtils.getUrlParameter(constants.paramSso);
	var isProfileParam = Framework.global.location.search && urlUtils.getUrlParameter(constants.paramProfileToken);
	if(!isSsoParam && !isProfileParam) {
		var token = Cookies.get(constants.cookieProfileToken) || null;
		if(token) {
			memberData = LocalStorage.get(constants.memberDetailsStorageKey);
		}
	}
	return memberData;
}

let data = {
	sso: null,
	authToken: null,
	ssoCreated: null,
	partyId: null,
	token: null,
	personalization: null,
	memberDetails: getInitialMemberData(),
	initialized: false,
	memberState: constants.memberState.unknown
};

ProfileStore = Reflux.createStore({
	// TODO REMOVE REFLUX: but we can't because of `.trigger()` and `.listen()`.
	// Callers in this repo do ProfileStore.listen(). Perhaps we could implement
	// listen here as a proxy to window.ef.profileStore.listen to solve that.
	// Then we could think through a way around the `trigger` calls below.
	initialize: () => {
		const efInitialProfileData = window.ef.profileStore.getInitialData();

		if(efInitialProfileData.initialized) {
			_.assign(data, efInitialProfileData);
			ProfileStore.trigger(data);
		} else{
			// TODO this path is used on first login when there is no cookie
			window.ef.profileStore.listen((efProfileData) => {
				_.assign(data, efProfileData);
				ProfileStore.trigger(data);
			});
		}
	},
	getInitialData: () => {
		return data;
	},
	onUpdateMeta: proxyToProfileStore('updateSchregSavedSearches'),
});

ProfileStore.name = 'ProfileStore';

Framework.registerStore(ProfileStore.name, ProfileStore);

export default ProfileStore;
